import { motion } from 'framer-motion';
import { SEO } from '../components/SEO';

export const PrivacyPage = () => {
  return (
    <main className="min-h-screen pt-32 pb-20" data-testid="privacy-page">
      <SEO title="Adatkezelési tájékoztató" description="Az Akadémia Plusz 2.0 Kft. adatkezelési tájékoztatója a GDPR és a magyar adatvédelmi szabályozás alapján." path="/adatvedelem" />
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto"
        >
          <h1 className="font-heading text-4xl md:text-5xl font-semibold text-white mb-8">
            Adatkezelési Tájékoztató
          </h1>

          <div className="glass-card p-8 md:p-12 space-y-12 text-white/70 leading-relaxed">

            {/* I. ÁLTALÁNOS INFORMÁCIÓK */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                I. Általános információk, az Adatkezelő
              </h2>

              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">I.1. Az adatkezelő személye és tevékenysége</h3>
                  <p>
                    A jelen Tájékoztatóban ("Tájékoztató") meghatározott adatkezelések tekintetében az adatkezelő az Akadémia Plusz 2.0 Korlátolt Felelősségű Társaság (székhely: 1027 Budapest, Kapás utca 6-12.; cégjegyzékszám: Cg. 01-09-322887; adószám: 26300575-2-41; képviseli: Gay Dymschiz ügyvezető; továbbiakban: "Adatkezelő").
                  </p>
                  <p className="mt-2">
                    Az Adatkezelő képzések szervezésével, bonyolításával foglalkozó, Magyarországon bejegyzett gazdasági társaság.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">I.2. Irányadó jogszabályok</h3>
                  <p>
                    Az Adatkezelő adatkezelésére elsősorban az Európai Unió általános adatvédelmi rendelete vonatkozik (Európai Parlament és a Tanács (EU) 2016/679 rendelete (2016. április 27.) a természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről és az ilyen adatok szabad áramlásáról, valamint a 95/46/EK rendelet hatályon kívül helyezéséről; továbbiakban: "GDPR"). Az adatkezelésre emellett irányadók azon magyar jogszabályok, amelyek az adatkezelő és az érintett közötti jogviszonyt szabályozzák, így különösen a Polgári Törvénykönyv, a felnőttképzésről szóló 2013. évi LXXVII. törvény ("Fktv."), valamint a szakképzésről szóló 2019. évi LXXX. törvény („Szktv.").
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">I.3. A Tájékoztató hatálya, az érintett</h3>
                  <p>
                    Jelen Tájékoztató hatálya kiterjed az Adatkezelő adatkezeléseire. Jelen Tájékoztató hatálya kizárólag a GDPR hatálya alá tartozó adatkezelésekre terjed ki.
                  </p>
                  <p className="mt-2">
                    A GDPR alapán személyes adat az azonosított vagy azonosítható természetes személyre ("érintett") vonatkozó bármely információ; azonosítható az a természetes személy, aki közvetlen vagy közvetett módon, különösen valamely azonosító, például név, szám, helymeghatározó adat, online azonosító vagy a természetes személy testi, fiziológiai, genetikai, szellemi, gazdasági, kulturális vagy szociális azonosságára vonatkozó egy vagy több tényező alapján azonosítható.
                  </p>
                  <p className="mt-2">
                    A jelen Tájékoztató hatálya alá tartozó adatkezelések esetében érintett az a személy, aki az Adatkezelővel jogviszonyban áll, állt, vagy ilyen jogviszony létrehozását kezdeményezi. Így különösen érintettek a képzésre jelentkező személyek, a képzéseken részt vevők, vizsgázók.
                  </p>
                  <p className="mt-2">
                    Mindezek alapján jelen Tájékoztató hatálya nem terjed ki azon adatokra, amelyek nem természetes személyekre vonatkoznak (pl. cégadatok), vagy amelyek nem hozhatók kapcsolatba természetes személyekkel (pl. statisztikai adatok, azon adatok, amelyek anonimizáltak).
                  </p>
                  <p className="mt-2">
                    Jelen Tájékoztató hatálya kizárólag az Adatkezelő adatkezelésére terjed ki.
                  </p>
                </div>
              </div>
            </section>

            {/* II. AZ ADATKEZELÉS ELVEI */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                II. Az adatkezelés elvei, célja, jogalapja, adatok felvétele
              </h2>

              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">II.1. Az adatkezelés elvei</h3>
                  <p>
                    Az Adatkezelő az adatokat jogszerűen, tisztességesen, és az érintett számára átlátható módon kezeli. Az Adatkezelő törekedik arra, hogy az általa kezelt adatok pontosak és naprakészek legyenek. Az Adatkezelő biztosítja az érintett jogainak érvényesülését, és megteszi a szükséges intézkedéseket annak érdekében, hogy az adatkezelés annak minden szakaszában jogszerű legyen.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">II.2. Az adatkezelés célja</h3>
                  <p className="mb-3">Az adatkezelés elsődleges célja az érintett és az Adatkezelő közötti jogviszony létrehozása, fenntartása. Ezen belül az adatkezelés céljai:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>az érintett azonosítása, kapcsolatfelvétel és kapcsolattartás;</li>
                    <li>az érintettel kötendő Szerződés előkészítése, megkötése, teljesítése;</li>
                    <li>a képzés szervezése, bonyolítása, a résztvevők regisztrálása és a részvétel nyomon követése;</li>
                    <li>az oktatáshoz kapcsolódó számonkérés, vizsgák szervezése, osztályozás;</li>
                    <li>tanúsítványok előkészítése és kiadása;</li>
                    <li>számlázás, fizetések kezelése;</li>
                    <li>jogviszonyból származó jogok gyakorlása, kötelezettségek teljesítése, igények érvényesítése;</li>
                    <li>jogszabályban elrendelt kötelezettségek teljesítése;</li>
                    <li>reklámozás.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">II.3. Az adatkezelés jogalapja</h3>
                  <p className="mb-3">
                    Figyelemmel arra, hogy az Adatkezelő több célból is kezel személyes adatot, az adatkezelés jogalapja is többféle lehet. A főbb jogalapok az alábbiak.
                  </p>

                  <h4 className="text-white/80 font-medium mt-4 mb-2">Az érintett hozzájárulása (GDPR 6. cikk (1) bek. a) pont)</h4>
                  <p>
                    Az adatkezelés jogalapja egyes esetekben az érintett hozzájárulása. Az érintett a hozzájárulását azzal adja meg, hogy az Adatkezelővel kapcsolatba lép, és kezdeményezi a jogviszony létrehozását. A hozzájárulás minden esetben önkéntes, azonban a hozzájárulás elmaradása eredményezheti azt, hogy az érintett és az Adatkezelő között a jogviszony nem jön létre. Az Adatkezelő az érintettet minden esetben tájékoztatja az adatkezelésről. Az érintett hozzájárulása a jogalap akkor, ha az érintett az adatkezelővel kapcsolatba lép, információt kér, vagy hozzájárul reklámok küldéséhez.
                  </p>

                  <h4 className="text-white/80 font-medium mt-4 mb-2">Az Adatkezelő és az érintett között létrejött szerződés (GDPR 6. cikk (1) bek. b) pont)</h4>
                  <p>
                    Amennyiben az érintett az Adatkezelővel szerződést köt, vagy azt kezdeményezi, a szerződésben és a kapcsolódó nyomtatványokon megadja azon adatait, amelyek szükségesek a szerződés teljesítéséhez. A jelen pont szerinti esetben az adatkezelés a szerződés teljesítése és az érintett által kezdeményezett lépések megtétele érdekében történik, a GDPR hivatkozott pontja alapján. Szerződéskötésnek minősül az is, ha az Adatkezelő és az érintett között a felek szóbeli, vagy egyéb nyilatkozatával jön létre jogviszony, így különösen, ha az érintett regisztrál valamely képzésre, és elfogadja annak feltételeit.
                  </p>
                  <p className="mt-2">
                    Amennyiben az érintett valamely, az Adatkezelő által kért, vagy szerződésben megjelölt adat kezeléséhez nem járul hozzá, jogában áll az adat megadását megtagadni. Amennyiben az adat kezelése jogszabály alapján kötelező, vagy az adat hiányában a szerződés nem teljesíthető, az adat megadásának hiányában a szerződés nem jön létre.
                  </p>

                  <h4 className="text-white/80 font-medium mt-4 mb-2">Jogszabályban foglalt kötelezettség teljesítése (GDPR 6. cikk (1) bek. c) pont)</h4>
                  <p>
                    Az adatkezelés jogalapja bizonyos esetekben jogszabály rendelkezése.
                  </p>
                </div>
              </div>
            </section>

            {/* III. AZ EGYES ADATKEZELÉSEK */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                III. Az egyes adatkezelések
              </h2>

              <div className="space-y-8">
                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">III.1. Bejelentéshez kötött felnőttképzési tevékenységgel kapcsolatos adatkezelés</h3>
                  <p className="mb-3">
                    Amennyiben az érintett részt kíván venni valamely, az Adatkezelő által szervezett, bejelentéshez kötött képzésen, az Adatkezelővel felnőttképzési szerződést kell kötnie. Figyelemmel arra, hogy az Adatkezelő az Fktv. hatálya alá tartozó szervezet, köteles az Fktv.-ban meghatározott adatokat kezelni. Az adatok kezelése a szerződés megkötéséhez szükséges.
                  </p>
                  <p className="font-medium text-white/80 mb-2">Kezelt adatok köre:</p>
                  <p className="mb-2">Az Adatkezelő, az Fktv. 21. §-a alapján a képzés lebonyolítása érdekében kezeli a képzésben részt vevő személy:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4 mb-3">
                    <li>természetes személyazonosító adatait és oktatási azonosító számát,</li>
                    <li>elektronikus levelezési címét,</li>
                    <li>legmagasabb iskolai végzettségére vonatkozó adatát,</li>
                    <li>a képzéssel összefüggő adatokat (végzettség, belépés/kilépés, értékelés, fizetési kötelezettségek).</li>
                  </ul>
                  <p className="mb-2">A tankötelezettsége teljesítése mellett felnőttképzésben is részt vevő kiskorú esetében az Adatkezelő kezeli az érintett szülője, törvényes képviselője nevét, lakóhelyét, tartózkodási helyét, telefonszámát.</p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés jogalapja:</p>
                  <p>A szerződés előkészítése, megkötése, teljesítése, valamint jogi kötelezettség teljesítése (Fktv. 21. §).</p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés időtartama:</p>
                  <p>Az adatokat az Adatkezelő fő szabályként a keletkezésüktől számított nyolc évig kezeli.</p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">III.2. A szakképzésről szóló 2019. évi LXXX. törvény hatálya szerint szervezett képzésen való részvétel</h3>
                  <p className="mb-3">
                    Amennyiben az érintett részt kíván venni valamely, az Adatkezelő által szervezett, Szktv. hatálya alá tartozó képzésen, az Adatkezelővel felnőttképzési szerződést kell kötnie.
                  </p>
                  <p className="font-medium text-white/80 mb-2">Kezelt adatok köre (Szktv. 114. § alapján):</p>
                  <ul className="list-disc list-inside space-y-1 ml-4 mb-3">
                    <li>természetes személyazonosító adatok, nem, állampolgárság,</li>
                    <li>lakcím, levelezési cím, e-mail cím, telefonszám,</li>
                    <li>társadalombiztosítási azonosító jel, adóazonosító jel,</li>
                    <li>kiskorú tanuló törvényes képviselőjének adatai,</li>
                    <li>tanulói jogviszonnyal kapcsolatos adatok (felvétel, mulasztás, értékelés, vizsgák, fegyelmi ügyek stb.),</li>
                    <li>kedvezményekre való jogosultság adatai.</li>
                  </ul>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés jogalapja:</p>
                  <p>A szerződés előkészítése, megkötése, teljesítése, valamint jogi kötelezettség teljesítése (Szktv. 114. §).</p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés időtartama:</p>
                  <p>Az adatokat az Adatkezelő fő szabályként a keletkezésüktől számított nyolc évig kezeli.</p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">III.3. Statisztikai adatszolgáltatással kapcsolatos adatkezelés</h3>
                  <p>
                    Az Adatkezelő, mint az Fktv. és az Szktv. hatálya alá tartozó szervezet, a 388/2017. (XII. 13.) Korm. rendelet alapján statisztikai adatszolgáltatásra kötelezett szervezet. Az adatok statisztikai célra felhasználhatók és statisztikai célú felhasználásra személyazonosításra alkalmatlan módon átadhatók.
                  </p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés jogalapja:</p>
                  <p>Jogi kötelezettség teljesítése (Fktv. 21. §, Szktv. 114. §).</p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">III.4. Harmadik fél által bonyolított képzéssel kapcsolatos adatkezelés</h3>
                  <p className="mb-3">
                    Amennyiben az érintett olyan képzésen vesz részt, amelyet az Adatkezelővel szerződéses jogviszonyban álló, de az Adatkezelőtől eltérő képző cég bonyolít, az érintett és az Adatkezelő között szerződés jön létre.
                  </p>
                  <p className="font-medium text-white/80 mb-2">Kezelt adatok köre:</p>
                  <p>Az érintett neve, születési név, születési hely és idő, anyja születési neve, lakóhelye, adóazonosító jele.</p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés jogalapja:</p>
                  <p>A szerződés előkészítése, megkötése, teljesítése.</p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés időtartama:</p>
                  <p>A Szerződés megszűnését követő nyolc év.</p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">III.5. Reklámozási célú adatkezelés</h3>
                  <p className="mb-3">
                    Amennyiben az érintett ahhoz hozzájárul, az Adatkezelő jogosult arra, hogy az érintett megadott elérhetőségeit (e-mail címét, postai címét, telefonszámát) felhasználja reklámozási célra. Az érintett a hozzájárulását bármikor visszavonhatja.
                  </p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés jogalapja:</p>
                  <p>Az érintett hozzájárulása.</p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés időtartama:</p>
                  <p>Az adatokat az Adatkezelő törli, ha az érintett azt kéri, vagy tiltakozik az adatok kezelése ellen.</p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">III.6. Díjfizetéssel kapcsolatos adatkezelés</h3>
                  <p className="mb-3">
                    Amennyiben az Adatkezelő és az érintett között olyan szerződés jön létre, amely alapján az érintett az Adatkezelő részére díjat fizet, az Adatkezelő nyilvántartja a díjfizetéssel kapcsolatos adatokat.
                  </p>
                  <p className="font-medium text-white/80 mb-2">Kezelt adatok köre:</p>
                  <p>A számlán szereplő adatok (érintett vagy költségviselő neve, címe, adószáma, fizetett tételek).</p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés jogalapja:</p>
                  <p>A szerződés teljesítése, jogszabály rendelkezése (Számviteli törvény 169. §).</p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés időtartama:</p>
                  <p>A bizonylat kiállítását követő nyolc év.</p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">III.7. Hatósági, végrehajtói, bírósági megkeresések</h3>
                  <p>
                    Amennyiben az Adatkezelő megkeresést kap hatóságtól, végrehajtótól, bíróságtól valamely munkavállalóra vonatkozóan, és a megkeresés a vonatkozó jogszabályoknak megfelel, az Adatkezelő a megkeresést iktatja, és azt teljesíti.
                  </p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés jogalapja:</p>
                  <p>Az a jogszabályi felhatalmazás, amelyen a megkeresés alapul.</p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés időtartama:</p>
                  <p>Az Adatkezelő öt év elteltével törli az adatokat.</p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">III.8. Weboldal adatkezelése</h3>
                  <p className="mb-3">
                    Amennyiben az érintett az Adatkezelő által fenntartott weboldalon regisztrál, és megadja adatait, azokat az Adatkezelő, mint a weboldal fenntartója kezeli. Az adatkezelés célja — az érintett által igénybe vett szolgáltatástól függően — hírlevél küldése, vagy az érintett által kezdeményezett szerződés előkészítése, képzésen történő regisztrálása.
                  </p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés jogalapja:</p>
                  <p>Az érintett hozzájárulása. Amennyiben az érintett szerződés létrehozását kezdeményezi a weboldalon keresztül, a jogalap a szerződés.</p>
                  <p className="font-medium text-white/80 mt-3 mb-1">Az adatkezelés időtartama:</p>
                  <p>Az adatkezelés addig tart, amíg az érintett a hozzájárulását vissza nem vonja, vagy az adatkezelés célja nyilvánvalóan megszűnik.</p>
                </div>
              </div>
            </section>

            {/* IV. EGYÉB INFORMÁCIÓK */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                IV. Egyéb, az adatkezeléssel kapcsolatos információk
              </h2>

              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">IV.1. Adattovábbítás</h3>
                  <p>
                    Az Adatkezelő személyes adatot csak akkor továbbít harmadik személy részére, ha ahhoz az érintett egyértelműen — a továbbított adatkör és az adattovábbítás címzettje ismeretében — hozzájárult, az adattovábbításra az adatkezelő és az érintett között létrejött szerződés arra megfelelő jogalapot nyújt, vagy az adattovábbításra jogszabály felhatalmazást ad.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">IV.2. Adatfeldolgozás</h3>
                  <p>
                    Az Adatkezelő a tevékenysége ellátásához jogosult adatfeldolgozót igénybe venni. Az adatfeldolgozók önálló döntést nem hoznak, az adatkezelés során az Adatkezelővel kötött írásbeli szerződés alapján, a szerződésben meghatározottak és az Adatkezelő utasítása szerint, az Adatkezelő nevében járnak el. Az Adatkezelő ellenőrzi az adatfeldolgozók munkáját.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">IV.3. Adatbiztonság, hozzáférés az adatokhoz</h3>
                  <p className="mb-3">
                    Az Adatkezelő gondoskodik az adatok biztonságáról, megteszi azokat a technikai és szervezési intézkedéseket és kialakítja azokat az eljárási szabályokat, amelyek az adatbiztonság követelményének érvényesülését biztosítják.
                  </p>
                  <p className="mb-2">Az Adatkezelő az informatikai védelemmel kapcsolatos feladatai körében gondoskodik különösen:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>A jogosulatlan hozzáférés elleni védelmet biztosító intézkedésekről (hozzáférés védelem, hálózati védelem);</li>
                    <li>Az adatállományok helyreállításának lehetőségét biztosító intézkedésekről (tükrözés, biztonsági mentés);</li>
                    <li>Az adatállományok vírusok elleni védelméről;</li>
                    <li>Az adatállományok fizikai védelméről (tűzkár, vízkár, villámcsapás elleni védelem).</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">IV.4. Az adatkezelés időtartama</h3>
                  <p className="mb-2">Az Adatkezelő a törlésre vonatkozó szabályok kialakításával biztosítja, hogy a személyes adatok kezelésének időtartama ne haladja meg a szükséges és jogszerű mértéket. Az adatok törlésére az alábbi esetekben kerül sor:</p>
                  <ul className="list-disc list-inside space-y-2 ml-4">
                    <li>Bizonyossá válik, hogy az adatok kezelése jogellenes.</li>
                    <li>Az adatok törlését az érintett kéri.</li>
                    <li>Az adatkezelés célja megszűnt, vagy az adatok tárolásának határideje lejárt.</li>
                    <li>Az adatok törlését bíróság vagy hatóság elrendelte.</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">IV.5. Adatvédelmi incidensek kezelése</h3>
                  <p>
                    Adatvédelmi incidens a biztonság olyan sérülése, amely a továbbított, tárolt vagy más módon kezelt személyes adatok véletlen vagy jogellenes megsemmisítését, elvesztését, megváltoztatását, jogosulatlan közlését vagy az azokhoz való jogosulatlan hozzáférést eredményezi. Az Adatkezelő az adatvédelmi incidenst haladéktalanul bejelenti az illetékes hatóságnak, kivéve, ha az adatvédelmi incidens valószínűsíthetően nem jár kockázattal az érintettek jogaira és szabadságaira nézve.
                  </p>
                </div>
              </div>
            </section>

            {/* VI. AZ ÉRINTETTEK JOGAI */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                V. Az érintettek jogai és érvényesítésük
              </h2>

              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">V.1. Az érintettek jogai</h3>

                  <h4 className="text-white/80 font-medium mt-4 mb-2">Tájékoztatás (hozzáférés)</h4>
                  <p>Az érintettnek joga van ahhoz, hogy az adatainak kezeléséről tájékoztatást kapjon. Az érintett az adatkezelés folyamán bármikor teljes körű tájékoztatást kérhet az adatai kezeléséről. Az érintett kérheti, hogy az Adatkezelő az adatok másolatát bocsássa a rendelkezésére.</p>

                  <h4 className="text-white/80 font-medium mt-4 mb-2">Helyesbítés</h4>
                  <p>Az érintett kérheti, hogy az Adatkezelő a rá vonatkozó pontatlan adatokat helyesbítse, a hiányos adatot kiegészítse.</p>

                  <h4 className="text-white/80 font-medium mt-4 mb-2">Törlés, hozzájárulás visszavonása</h4>
                  <p>Az érintett bármikor visszavonhatja az adatai kezeléséhez adott hozzájárulását, kérheti az adatai törlését. Az Adatkezelő a törlést csak akkor tagadja meg, amennyiben az adatkezelés jogszabályon alapul, vagy az adatkezelés szükséges jogi igények előterjesztéséhez, érvényesítéséhez, illetve védelméhez.</p>

                  <h4 className="text-white/80 font-medium mt-4 mb-2">Korlátozás</h4>
                  <p className="mb-2">Az érintettnek jogában áll az adatkezelés korlátozását kérni, az alábbi esetekben:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4">
                    <li>az érintett vitatja a személyes adatok pontosságát;</li>
                    <li>az adatkezelés jogellenes, és az érintett ellenzi az adatok törlését;</li>
                    <li>az adatkezelőnek már nincs szüksége a személyes adatokra, de az érintett igényli azokat jogi igények érvényesítéséhez;</li>
                    <li>az érintett tiltakozott az adatkezelés ellen.</li>
                  </ul>

                  <h4 className="text-white/80 font-medium mt-4 mb-2">Tiltakozás</h4>
                  <p>Amennyiben az adatkezelés az Adatkezelő, vagy harmadik fél jogos érdekének érvényesítésén alapul, az érintett jogosult arra, hogy a saját helyzetével kapcsolatos okokból bármikor tiltakozzon személyes adatainak kezelése ellen.</p>

                  <h4 className="text-white/80 font-medium mt-4 mb-2">Adathordozhatóság</h4>
                  <p>Az érintett jogosult arra, hogy a rá vonatkozó személyes adatokat tagolt, széles körben használt, géppel olvasható formátumban megkapja, továbbá jogosult arra, hogy ezeket az adatokat egy másik adatkezelőnek továbbítsa.</p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">V.2. Az érintett jogainak biztosítása</h3>
                  <p className="mb-3">
                    Az Érintett jogait az alábbi módokon gyakorolhatja:
                  </p>
                  <ul className="list-disc list-inside space-y-2 ml-4">
                    <li>E-mailen az <a href="mailto:akademia@dh.hu" className="text-[#56999B] hover:text-[#C4DB72] transition-colors">akademia@dh.hu</a> címre küldött levélben;</li>
                    <li>Postai úton az Akadémia Plusz 2.0 Kft. részére, a 1027 Budapest, Kapás utca 6-12. címre küldött levélben;</li>
                    <li>Telefonon, a <a href="tel:+3615552222" className="text-[#56999B] hover:text-[#C4DB72] transition-colors">+36-1-555-2222</a> számon.</li>
                  </ul>
                  <p className="mt-3">
                    Az Adatkezelő a kérelmet haladéktalanul megvizsgálja, és döntést hoz a kérelem teljesítéséről, majd megteszi a szükséges intézkedéseket. Az Adatkezelő a megtett intézkedésekről egy hónapon belül tájékoztatja az érintettet. Az Adatkezelő a kérelem teljesítését nem köti díj fizetéséhez.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-white/90 mb-3">V.3. Jogorvoslat</h3>
                  <p className="mb-3">
                    Az érintett a jogainak sérelme esetén kérheti, hogy az Adatkezelő a jogellenes adatkezelést szüntesse meg. Az Adatkezelő az érintett panaszát minden esetben kivizsgálja, és annak eredményéről az érintettet tájékoztatja.
                  </p>
                  <p className="mb-3">
                    Az érintett panaszával fordulhat közvetlenül a Nemzeti Adatvédelmi és Információszabadság Hatósághoz:
                  </p>
                  <ul className="list-none space-y-1 ml-4">
                    <li><span className="text-white/80">Cím:</span> 1055 Budapest, Falk Miksa utca 9-11.</li>
                    <li><span className="text-white/80">Telefon:</span> +36-1-391-1400</li>
                    <li><span className="text-white/80">E-mail:</span> ugyfelszolgalat@naih.hu</li>
                    <li><span className="text-white/80">Honlap:</span> www.naih.hu</li>
                  </ul>
                  <p className="mt-3">
                    Az érintett jogosult jogainak megsértése esetén bírósághoz fordulni.
                  </p>
                </div>
              </div>
            </section>

          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default PrivacyPage;
